import { Component, Prop, Vue } from 'vue-property-decorator'
import ConfigurationRelationships
    from '@/modules/configurationModule/shared/components/configuration-relationships/configuration-relationships.vue'
import { ConfigurationPersonnelResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel/configuration-personnel.dto'
import {
    ConfigurationAutomationPersonnelEntitiesAssociationModalProcedureAssignmentFormState,
    initialConfigurationAutomationPersonnelEntitiesAssociationModalProcedureAssignmentFormState
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal-procedure-assignment-form/configuration-automation-personnel-entities-association-modal-procedure-assignment-form.model'
import { CommonProcedureResponse } from '@/api/services/common/procedure/common-procedure.dto'
import { commonProcedureService } from '@/api/services/common/procedure/common-procedure.service'
import {
    ConfigurationPersonnelProcedureAssignmentCreateRequest,
    ConfigurationPersonnelProcedureAssignmentResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-procedure-assignment/configuration-personnel-procedure-assignment.dto'
import { configurationPersonnelProcedureAssignmentService } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-procedure-assignment/configuration-personnel-procedure-assignment.service'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { GridUtils } from '@/shared/util/grid-utils'

@Component({
    components: {
        ConfigurationRelationships
    }
})
export default class ConfigurationAutomationPersonnelEntitiesAssociationModalProcedureAssignmentForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly personnel!: ConfigurationPersonnelResponse

    state: ConfigurationAutomationPersonnelEntitiesAssociationModalProcedureAssignmentFormState
    constructor() {
        super()
        this.state = initialConfigurationAutomationPersonnelEntitiesAssociationModalProcedureAssignmentFormState()
    }

    private async _loadProcedures(): Promise<void> {
        this.state.procedures = await this._getProcedures()
    }

    private async _loadPersonnelProcedureAssignments(): Promise<void> {
        this.state.personnelProcedureAssignments = await this._getPersonnelProcedureAssignments()
    }

    async mounted() {
        await this._loadProcedures()
        await this._loadPersonnelProcedureAssignments()
    }

    /// SERVICES CALLS ///

    private async _getProcedures(): Promise<CommonProcedureResponse[]> {
        const response = await this.$_toCallUnique(commonProcedureService.getProcedures())
        if (response) {
            return response
        }
        return []
    }

    private async _getPersonnelProcedureAssignments(): Promise<ConfigurationPersonnelProcedureAssignmentResponse[]> {
        const filterModel: CommonFilterModel = {
            'personnel.id': GridUtils.getNumberFilterModel('equals', this.personnel.id)
        }
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallUnique(configurationPersonnelProcedureAssignmentService.paginator(filterModel, params, this.state.laboratoryId))
        if (response) {
            return response.content
        }
        return []
    }

    private async _createPersonnelProcedureAssignment(createRequest: ConfigurationPersonnelProcedureAssignmentCreateRequest): Promise<ConfigurationPersonnelProcedureAssignmentResponse | null> {
        const response = await this.$_toCallUnique(configurationPersonnelProcedureAssignmentService.create(this.state.laboratoryId, createRequest))
        if (response) {
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.created'))
            return response
        }
        return null
    }

    private async _deletePersonnelProcedureAssignment(personnelProcedureAssignmentId: number): Promise<void> {
        if (personnelProcedureAssignmentId) {
            await this.$_toCallUnique(configurationPersonnelProcedureAssignmentService.delete(personnelProcedureAssignmentId, this.state.laboratoryId))
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.deleted'))
        }
    }

    /// FORM OPERATIONS ///

    async createOperation(procedure: CommonProcedureResponse): Promise<void> {
        if (procedure) {
            const createRequest: ConfigurationPersonnelProcedureAssignmentCreateRequest = {
                personnelId: this.personnel.id,
                procedureId: procedure.id
            }
            if (await this._createPersonnelProcedureAssignment(createRequest)) {
                await this._loadPersonnelProcedureAssignments()
            }
        }
    }

    async deleteOperation(personnelProcedureAssignment: ConfigurationPersonnelProcedureAssignmentResponse): Promise<void> {
        if (personnelProcedureAssignment) {
            await this._deletePersonnelProcedureAssignment(personnelProcedureAssignment.id)
            await this._loadPersonnelProcedureAssignments()
        }
    }
}
